
interface AboutProps {
  onOpenModal: () => void;
}

export default function About({ onOpenModal }: AboutProps) {
  return (
    <section id="about" className="py-28 bg-[#FDFCFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-16 items-start">
          <div className="md:col-span-5">
            <div className="inline-block mb-6 px-5 py-2 border border-[#D4B137] rounded-full">
              <p className="text-black text-xs font-semibold tracking-widest uppercase">Our Story</p>
            </div>
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-black mb-8 leading-tight">
              39 Years of Framing Excellence
            </h2>
            <div className="space-y-6 text-black/70 text-base md:text-lg leading-relaxed">
              <p>
                Founded by Laurie Stokes in 1987, <strong>Laurie's Flash Framers</strong> has been a trusted name in Sherman Oaks and the San Fernando Valley for nearly four decades.
              </p>
              <p>
                For 39 years, we've served artists, celebrities, designers, studios, and collectors with one guiding philosophy: <strong>a frame should do more than protect, it should enhance and extend the artwork itself.</strong>
              </p>
              <p>
                Today, Brittany S. carries forward this family legacy with the same artistic eye and dedication to quality that Laurie built the business on. Every piece receives thoughtful design and expert craftsmanship using premium, museum-quality materials.
              </p>
            </div>
            <button
              onClick={onOpenModal}
              className="inline-flex items-center mt-8 px-8 py-4 bg-[#D4B137] text-black font-semibold rounded-full hover:bg-[#C4A127] transition-colors cursor-pointer whitespace-nowrap"
            >
              Book a Consultation
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
